import { frontendURL } from '../../../helper/URLHelper';
import AppointmentsIndex from './pages/AppointmentsIndex.vue';
import AppointmentsProfessional from './pages/AppointmentsProfessional.vue';

const commonMeta = {
  permissions: ['administrator', 'agent', 'manager'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/appointments/calendar'),
    component: AppointmentsIndex,
    meta: commonMeta,
    
    children: [
      {
        path: '',
        name: 'appointments_calendar',
        component: AppointmentsIndex,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/appointments/professionals'),
    component: AppointmentsProfessional,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'appointments_professionals',
        component: AppointmentsProfessional,
        meta: commonMeta,
      },
    ],
  }
  
];
